import axios from 'axios';
import { useMutation } from 'react-query';

export type LogoutMerchantGoogleAccountResponse = {
  code: string;
  message: string;
};

const logoutMerchantGoogleAccount = async (
  merchantId: string,
): Promise<LogoutMerchantGoogleAccountResponse> => {
  const { data } = await axios.delete(
    `/api/merchants/${merchantId}/merchant-google-account`,
  );
  return data;
};

export const useLogoutMerchantGoogleAccount = ({ onSuccess, onError }) => {
  return useMutation(logoutMerchantGoogleAccount, {
    onSuccess,
    onError,
  });
};
